<button [type]="question.buttonType" class="w-100 btn-lg btn-primary ratButton">{{question.label}}</button>

